export const QUOTAT = {
  QUOTEWAIT_QUOTATION: 3, // 报价单待报价
  QUOTEWAIT_AUDIT: 10, // 报价单待审核
  QUOTEFINISH: 5, // 报价单已同意
  QUOTEREJECT: 12, // 报价单已拒绝
  QUOTEREVOKE: 9, // 报价单撤销
};
// 询价单状态常量
export const INQUIRY = {
  INQUIRY_DRAFT: 2, // 草稿
  INQUIRY_WAIT_QUOTATION: 3, // 待报价
  INQUIRY_IN_QUOTATION: 4, // 进行中
  INQUIRY_FINISH_QUOTATION: 5, // 已完成
  INQUIRY_DESTROY: 9, // 已撤销
};
// 单据状态常量
export const ORDERSTATE = {
  DRAFT: 1, // 草稿
  WAIT: 4,
  PART: 5,
  END: 2,
  WAITPURCHASE: 2, // 采购待入库
  PARTPURCHASE: 3, // 采购部分入库
  ENDPURCHASE: 4, // 已采购
  PURCHASEWAITAUDIT: 10, //  采购待审核
  PURCHASEREJECT: 12, //  采购审核拒绝
  WAITSTOREW: 1, // 物料待出库、待入库
  PARTSTOREW: 2, // 物料部分出库、部分入库
  ENDSTOREW: 3, // 物料完成待出库、完成待入库
  GIVESTOREW: 4, // 物料放弃出库、放弃入库
  ENDSTORE: 2, // 物料已出库、已入库
  WAITOUTBOUNDPICK: 3, // 领料待出库、待入库
  PARTOUTBOUNDPICK: 4, // 领料部分出库、部分入库
  ENDOUTBOUNDPICK: 2, // 已领料、已退料
  WAITOUTBOUND: 4, // 生产待出库
  PARTOUTBOUND: 5, // 生产部分出库
  ENDINVENTORY: 2, // 物料已盘点
  ENDOUTBOUND: 2, // 成品已出库
  PARTFINISHOUTBOUND: 45, // 成品调拨部分出库
  REVOKE: 9, // 撤销
  RETAILlWAIT: 2, // 采购退货待出库
  RETAILlPART: 3, // 采购退货部分出库
  RETAILEND: 4, // 采购退货已退货
  WAITDELIVERY: 2, // 物料发货 待收货
  ENDELIVERY: 4, // 物料发货 已收货
  ENDSTOREIN: 6, // 次品返厂结束入库
  REFUSEEXAMINE: -3, // 物料发料拒绝审核
  CANCELEXAMINE: -2, // 物料发料取消审核
  WAITEXAMINE: -1, // 物料发料待审核
  PROCESSAUDITWAITSUBMIT: 0, // 工序审核待提交
  PROCESSAUDITWAITAUDIT: 1, // 工序审核待审核
  PROCESSAUDITCONSENT: 5, // 工序审核已同意
  PROCESSAUDITREJECT: 9, // 工序审核已拒绝
  WAITCONFIRM: 2, // 待工厂确认
  PLAN: 3, // 计划中
  ORDER: 4, // 下单生产
  PRODUCING: 5, // 生产中
  REQUESTFINISH: 6, // 请求单结束生产
  REQUESTREJECT: 7, // 请求单拒绝生产
  REQUESTREVOKE: 8, // 请求单撤销
  WAITRECEI: 21, // 成品出库待回款
  PARTRECEI: 22, // 成品出库部分回款
  ALLRECEI: 23, // 成品出库已回款
  ...QUOTAT,
  ...INQUIRY,
} as const;

// 库存流水单据状态常量
// export const stockFlowState = [
//   { val: 11, text: '生产入库' },
//   { val: 21, text: '生产出库' },
//   { val: 12, text: '成品入库' },
//   { val: 22, text: '成品出库' },
//   { val: 13, text: '成品待入库-生产入库' },
//   { val: 14, text: '成品待入库-成品调拨' },
//   { val: 23, text: '成品待出库-生产出库' },
//   { val: 24, text: '成品待出库-成品调拨' },
//   { val: 31, text: '成品调拨' },
//   { val: 41, text: '成品盘点' }
// ]

// 生产单单据状态常量
// 单据状态
export const produceOrderState = [
  {
    text: '草稿',
    val: ORDERSTATE.DRAFT,
  },
  {
    text: '待生产',
    val: ORDERSTATE.WAIT,
  },
  {
    text: '生产中',
    val: 2,
  },
  {
    text: '生产完成',
    val: 3,
  },
  {
    text: '已撤销',
    val: ORDERSTATE.REVOKE,
  },
];
// 物料盘点单据状态常量
export const materialInventoryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已盘点', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 成品盘点单据状态常量
export const finishedInventoryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已盘点', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 样衣盘点单据状态常量
export const designInventoryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已盘点', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 成品调拨单据状态常量
export const finishedTransferState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '完成', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 物料采购单据状态常量
export const materialPurchaseState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'plainBlue' },
  { val: ORDERSTATE.WAITPURCHASE, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTPURCHASE, text: '部分入库', color: 'yellow' },
  { val: ORDERSTATE.ENDPURCHASE, text: '已采购', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
  { val: ORDERSTATE.PURCHASEWAITAUDIT, text: '审批中', color: 'yellow' },
  { val: ORDERSTATE.PURCHASEREJECT, text: '拒绝', color: 'red' },
];

// 物料待入库单据状态常量
export const materialStoreWinState = [
  { val: ORDERSTATE.WAITSTOREW, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTSTOREW, text: '部分入库', color: 'yellow' },
  { val: ORDERSTATE.ENDSTOREW, text: '已入库', color: 'green' },
  { val: ORDERSTATE.GIVESTOREW, text: '放弃入库', color: 'plainBlue' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
export const materialStoreInState = [
  { val: ORDERSTATE.ENDSTORE, text: '已入库', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
export const materialStoreWoutState = [
  { val: ORDERSTATE.WAITSTOREW, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTSTOREW, text: '部分出库', color: 'yellow' },
  { val: ORDERSTATE.ENDSTOREW, text: '已出库', color: 'green' },
  { val: ORDERSTATE.GIVESTOREW, text: '放弃出库', color: 'plainBlue' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
export const materialStoreOutState = [
  { val: ORDERSTATE.ENDSTORE, text: '已出库', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 物料调拨单据状态常量
export const materialTransferState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '完成', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 领料 or 退料
export const pickOrderType = {
  PICK: 1, // 领料
  RETURN: 2, // 退料
};
// 物料领料单据状态常量
export const materialPickingState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUNDPICK, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUNDPICK, text: '部分出库', color: 'orange' },
  { val: ORDERSTATE.ENDOUTBOUNDPICK, text: '已领料', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 物料退料单据状态常量
export const materialReturnState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUNDPICK, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUNDPICK, text: '部分入库', color: 'orange' },
  { val: ORDERSTATE.ENDOUTBOUNDPICK, text: '已退料', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 商品出库单据状态常量
export const outboundOrderState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '部分出库', color: 'orange' },
  { val: ORDERSTATE.ENDOUTBOUND, text: '已出库', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 成品出库回款状态
export const outboundReceiveState = [
  {
    val: ORDERSTATE.WAITRECEI,
    text: '待回款',
    color: 'orange',
    orderCountField: 'waitPaymentTabCount',
  },
  { val: ORDERSTATE.PARTRECEI, text: '部分回款', color: 'orange' },
  { val: ORDERSTATE.ALLRECEI, text: '已回款', color: 'green' },
];
// 次品返厂单据状态常量
export const goodsReworkOrderState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAIT, text: '待入库', color: 'orangeRed' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '部分入库', color: 'orange' },
  { val: ORDERSTATE.END, text: '已入库', color: 'green' },
  { val: ORDERSTATE.ENDSTOREIN, text: '结束入库', color: 'red' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 借还单据状态常量
export const borrowOrderState = [
  { val: ORDERSTATE.WAIT, text: '待归还', color: 'orangeRed' },
  { val: ORDERSTATE.PART, text: '部分归还', color: 'orange' },
  { val: ORDERSTATE.END, text: '已归还', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 归还单据状态常量
export const backOrderState = [
  { val: ORDERSTATE.END, text: '已归还', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 采购退货单据状态常量
export const purchaseRetailState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.RETAILlWAIT, text: '待出库', color: 'orangeRed' },
  { val: ORDERSTATE.RETAILlPART, text: '部分出库', color: 'orange' },
  { val: ORDERSTATE.RETAILEND, text: '已退货', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '撤销', color: 'gray' },
];
// 物料采购-发货状态常量
export const DeliveryState = [
  { val: 2, text: '待发货', color: 'orangeRed' },
  { val: 3, text: '部分发货', color: 'orange' },
  { val: 4, text: '已完成', color: 'green' },
];
// 物料发货单据状态常量
export const deliveryOrderState = [
  { val: ORDERSTATE.WAITDELIVERY, text: '待收货', color: 'orangeRed' },
  { val: ORDERSTATE.ENDELIVERY, text: '已收货', color: 'green' },
];
// 物料发料单据状态常量
export const materialSendState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITEXAMINE, text: '待审核', color: 'yellow' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已完成', color: 'green' },
  { val: ORDERSTATE.REFUSEEXAMINE, text: '拒绝', color: 'red' },
  { val: ORDERSTATE.CANCELEXAMINE, text: '取消审核', color: 'gray' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 物料发料单据审核状态常量
export const materialIssueAuditState = [
  { val: ORDERSTATE.WAITEXAMINE, text: '提交发料', color: 'black' },
  { val: ORDERSTATE.REFUSEEXAMINE, text: '拒绝发料', color: 'red' },
  { val: ORDERSTATE.CANCELEXAMINE, text: '取消审核', color: 'gray' },
];
// 物料回料单据状态常量
export const materialRecoveryState = [
  { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITOUTBOUND, text: '待出库', color: 'yellow' },
  { val: ORDERSTATE.PARTOUTBOUND, text: '待入库', color: 'yellow' },
  { val: ORDERSTATE.PARTFINISHOUTBOUND, text: '待出入库', color: 'orange' },
  { val: ORDERSTATE.ENDINVENTORY, text: '已完成', color: 'green' },
  { val: ORDERSTATE.REVOKE, text: '已撤销', color: 'gray' },
];
// 工序审核状态常量
export const processAutditState = [
  { val: ORDERSTATE.PROCESSAUDITWAITSUBMIT, text: '待提交', color: 'gray' },
  { val: ORDERSTATE.PROCESSAUDITWAITAUDIT, text: '待审核', color: 'orange' },
  { val: ORDERSTATE.PROCESSAUDITCONSENT, text: '已同意', color: 'green' },
  { val: ORDERSTATE.PROCESSAUDITREJECT, text: '已拒绝', color: 'red' },
];

// 设计款状态
export const DESIGN_STATUS = {
  INDESIGN: 2, // 设计中
  WAIT: 3, // 待确定
  MODIFY: 4, // 修改中
  APPROVED: 5, // 审核通过
  CANCEL: 9, // 取消
};
// 设计款状态列表
export const designProState = [
  {
    val: DESIGN_STATUS.INDESIGN,
    text: '设计中',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
  },
  {
    val: DESIGN_STATUS.WAIT,
    text: '待确定',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
    orderCountField: 'toBeConfirmedCount',
  },
  {
    val: DESIGN_STATUS.MODIFY,
    text: '修改中',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
    orderCountField: 'underEditCount',
  },
  {
    val: DESIGN_STATUS.APPROVED,
    text: '审核通过',
    color: 'green',
    tc: '#04C160',
    bg: '#D6F9E7',
  },
  {
    val: DESIGN_STATUS.CANCEL,
    text: '取消',
    color: 'gray',
    tc: '#979797',
    bg: '#EAEAEA',
  },
];

export const StateInfo = [
  { name: '正常流水', state: 2, isRevoke: 0, color: '#00b42a' },
  { name: '已撤销', state: 0, isRevoke: 1, recordType: 0, color: '#86909c' },
  {
    name: '撤销冲抵',
    state: 1,
    isRevoke: 1,
    recordType: 1,
    color: '#f53f3f',
  },
];

// 生产单-bom的发料状态
export const bomIssueState = [
  { val: 2, text: '无需发料', color: 'black' },
  { val: 1, text: '发料中', color: 'orange' },
  { val: 3, text: '发料结束', color: 'green' },
];
export const bomCompleteState = [
  { val: 0, text: '未齐', color: 'orange' },
  { val: 1, text: '齐料', color: 'green' },
];
// 生产请求单
// 单据状态  1-草稿 2-待工厂确认 3-计划中 4-下单生产 5-生产中 6-结束生产 7.拒绝生产 8-撤销
export const REQUEST_ORDER_OPTIONS = [
  // { val: ORDERSTATE.DRAFT, text: '草稿', color: 'blue' },
  { val: ORDERSTATE.WAITCONFIRM, text: '待工厂确认', color: 'orangeRed' },
  { val: ORDERSTATE.PLAN, text: '计划中', color: 'orange' },
  { val: ORDERSTATE.ORDER, text: '下单生产', color: 'blue' },
  { val: ORDERSTATE.PRODUCING, text: '生产中', color: 'orange' },
  { val: ORDERSTATE.REQUESTFINISH, text: '结束生产', color: 'green' },
  { val: ORDERSTATE.REQUESTREJECT, text: '拒绝生产', color: 'red' },
  { val: ORDERSTATE.REQUESTREVOKE, text: '撤销', color: 'gray' },
];

// 询价单状态列表
export const InquiryOrderState = [
  {
    val: ORDERSTATE.INQUIRY_DRAFT,
    tab: 2,
    text: '草稿',
    color: 'blue',
  },
  {
    val: ORDERSTATE.INQUIRY_WAIT_QUOTATION,
    text: '待报价',
    tab: 3,
    orderCountField: 'waitQuotationCount',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
  },
  {
    val: QUOTAT.QUOTEWAIT_AUDIT,
    text: '待审核',
    tab: QUOTAT.QUOTEWAIT_AUDIT,
    orderCountField: 'waitAuditCount',
    color: 'yellow',
  },
  {
    val: QUOTAT.QUOTEREJECT,
    text: '已拒绝',
    tab: QUOTAT.QUOTEREJECT,
    color: 'red',
  },
  {
    val: ORDERSTATE.INQUIRY_IN_QUOTATION,
    text: '进行中',
    tab: 4,
    orderCountField: 'inQuotationCount',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
  },
  {
    val: ORDERSTATE.INQUIRY_FINISH_QUOTATION,
    text: '已完成',
    tab: 5,
    color: 'green',
    tc: '#04C160',
    bg: '#D6F9E7',
  },
  {
    val: ORDERSTATE.INQUIRY_DESTROY,
    text: '已撤销',
    tab: 9,
    color: 'gray',
    tc: '#979797',
    bg: '#EAEAEA',
  },
];

// 报价单状态列表
export const QuoteOrderState = [
  {
    val: ORDERSTATE.QUOTEWAIT_QUOTATION,
    text: '待报价',
    color: 'gray',
  },
  {
    val: ORDERSTATE.QUOTEWAIT_AUDIT,
    text: '待审核',
    color: 'yellow',
    tc: '#FF8F1F',
    bg: '#FFEEDC',
  },
  {
    val: ORDERSTATE.QUOTEFINISH,
    text: '已同意',
    color: 'green',
    tc: '#04C160',
    bg: '#D6F9E7',
  },
  {
    val: ORDERSTATE.QUOTEREJECT,
    text: '已拒绝',
    color: 'red',
  },
  {
    val: ORDERSTATE.QUOTEREVOKE,
    text: '已撤销',
    color: 'gray',
  },
];
// 工序审核日志状态常量
export const QuoteOrderAutditlogState = [
  { val: 16, text: '修改加工费', color: 'color-yellow' },
  { val: 12, text: '拒绝', color: 'red' },
  { val: 11, text: '已同意', color: 'green' },
  { val: 15, text: '取消审核', color: 'color-6296f0' },
  { val: 17, text: '撤销审核', color: 'gray' },
  { val: 10, text: '提交审核', color: 'color-theme' },
  // 下面是后端使用
  { val: 21, text: '结束报价', color: 'color-theme' },
  { val: 3, text: '提交', color: 'color-theme' },
];
// 用料中心
export const MATERIAL_CENTER_OPTIONS = [
  { val: 0, text: '进行中', color: 'orange' },
  { val: 1, text: '结束用料', color: 'green' },
  { val: 9, text: '撤销', color: 'gray' },
];
// 默认菜单常量
export const defaultOrderState: Recordable[] = [
  { val: 0, text: '默认', tab: 0 },
];

export const reportCommonTab = [
  {
    text: '汇报明细',
    val: 1,
  },
  {
    text: '汇总统计',
    val: 2,
  },
] as const;
// 版单汇报方式
export const reportTypeListFromEdition = [
  {
    text: '整体完成',
    value: 3,
    className: 'w200',
  },
  {
    text: '汇报数量',
    value: 2,
    className: 'w200',
  },
];
// 工序节点汇报方式 1: 汇报整体数量 2：分色码汇报数量 3：整体完成
export const reportTypeListFromProd = [
  {
    text: '汇报整体数量',
    value: 1,
  },
  {
    text: '分色码汇报数量',
    value: 2,
  },
  {
    text: '整体完成',
    value: 3,
  },
];
// 费用预支状态
export const ADVANCE_STATUS = {
  DRAFT: 2, // 草稿
  WAIT_AUDIT: 3, // 待审批
  WAIT_PAY: 4, // 待付款
  PAY: 5, // 完成
  REVOKE: 9, // 撤销
  REJECT: 12, // 拒绝
};
export const ADVANCE_STATUS_OPTIONS = [
  {
    text: '草稿',
    val: ADVANCE_STATUS.DRAFT,
    color: 'blue', // 列表状态颜色
    detailColor: 'blue', // 详情状态颜色
  },
  {
    text: '审批中',
    val: ADVANCE_STATUS.WAIT_AUDIT,
    color: 'orange',
    detailColor: 'orange',
    orderCountField: 'waitAuditCount',
  },
  {
    text: '待付款',
    val: ADVANCE_STATUS.WAIT_PAY,
    color: 'orange',
    detailColor: 'orange',
    orderCountField: 'waitPayCount',
  },
  {
    text: '已付款',
    val: ADVANCE_STATUS.PAY,
    color: 'green',
    detailColor: '#04C160',
  },
  {
    text: '拒绝',
    val: ADVANCE_STATUS.REJECT,
    color: 'red',
    detailColor: '#E11919',
    orderCountField: 'rejectCount',
  },
  {
    text: '撤销',
    val: ADVANCE_STATUS.REVOKE,
    color: 'gray',
    detailColor: '#E11919',
  },
];
// 费用报销状态
export const EXPENSE_STATUS = {
  DRAFT: 2, // 草稿
  WAIT_AUDIT: 3, // 待审批
  WAIT_PAY: 4, // 待付款
  WAIT_RECEIVE: 16, // 待收款
  PAY: 5, // 已付款
  REVOKE: 9, // 撤销
  AGREE: 11, // 已同意
  REJECT: 12, // 拒绝
};
export const EXPENSE_STATUS_OPTIONS = [
  {
    text: '草稿',
    val: EXPENSE_STATUS.DRAFT,
    color: 'blue', // 列表状态颜色
    detailColor: 'blue', // 详情状态颜色
  },
  {
    text: '审批中',
    val: EXPENSE_STATUS.WAIT_AUDIT,
    color: 'orange',
    detailColor: 'orange',
    orderCountField: 'waitAuditCount',
  },
  {
    text: '待付款',
    val: EXPENSE_STATUS.WAIT_PAY,
    color: 'orange',
    detailColor: 'orange',
    orderCountField: 'waitPayCount',
  },
  {
    text: '待收款',
    val: EXPENSE_STATUS.WAIT_RECEIVE,
    color: 'orange',
    detailColor: 'orange',
  },
  {
    text: '完成',
    val: EXPENSE_STATUS.PAY,
    color: 'green',
    detailColor: '#04C160',
  },
  {
    text: '拒绝',
    val: EXPENSE_STATUS.REJECT,
    color: 'red',
    detailColor: '#E11919',
    orderCountField: 'rejectCount',
  },
  {
    text: '撤销',
    val: EXPENSE_STATUS.REVOKE,
    color: 'gray',
    detailColor: '#E11919',
  },
];
export const queryCacheKeyMap = {
  EDITIONREPORT_ORDER_QUERY: 'EDITIONREPORT_ORDER_QUERY',
  PRODREPORT_ORDER_QUERY: 'PRODREPORT_ORDER_QUERY',
};
export default {
  ORDERSTATE,
  // stockFlowState,
  materialInventoryState,
  finishedInventoryState,
  finishedTransferState,
  materialTransferState,
  materialPickingState,
  materialReturnState,
  outboundOrderState,
  goodsReworkOrderState,
  defaultOrderState,
  borrowOrderState,
  backOrderState,
  purchaseRetailState,
  deliveryOrderState,
  materialSendState,
  materialIssueAuditState,
  materialRecoveryState,
  processAutditState,
  StateInfo,
  bomIssueState,
  DESIGN_STATUS,
  designProState,
  REQUEST_ORDER_OPTIONS,
};
